module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.redefine.js
// module id = 196
// module chunks = 0